var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.479 464.505C191.302 402.802 175.073 314.958 196.635 227.156C70.3542 331.417 36.8385 515.391 124.833 659.036C125.854 660.698 126.911 662.365 127.974 663.99L128.802 663.464C123.661 629.109 138.943 593.474 170.38 574.182C196.37 558.255 227.24 557.271 253.156 568.734C241.276 545.693 224.401 509.26 210.479 464.505Z",
    fill: "#14385C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.021 175.74C364.302 198.25 431.568 248.641 476.474 290.901C515.854 327.974 543.74 363.536 558.229 383.589C559.25 354.682 574.229 326.802 600.75 310.573C630.865 292.109 667.635 293.698 695.516 311.516C695.214 310.99 694.911 310.458 694.609 309.969C607.484 167.833 431.229 113.812 282.021 175.74Z",
    fill: "#14385C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M461.906 305.542C414.505 261.01 341.229 206.953 252.057 189.927C246.385 192.99 240.745 196.172 235.187 199.615C231.443 201.922 227.734 204.302 224.099 206.724C193.156 298.01 209.953 393.307 230.229 458.339C243.964 502.417 260.875 538.62 272.411 560.786C277.37 525.568 313.646 474.307 382.995 431.255C451.318 388.807 507.531 382.755 540.333 394.104C525.88 374.432 498.948 340.344 461.906 305.542Z",
    fill: "#14385C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M635.516 824.13L376.635 401.594L352.198 416.536L601.958 824.13H635.516Z",
    fill: "#14385C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_27",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 368,
    y: 662,
    width: 674,
    height: 310
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M368 662.667H1041.33V971.875H368V662.667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031.12 663.99H999.453C995.896 663.99 992.646 665.958 990.979 669.099L896.365 848.76C894.698 851.901 891.443 853.865 887.891 853.865H377.807C372.516 853.865 368.24 858.141 368.24 863.437V962.214C368.24 967.51 372.516 971.786 377.807 971.786H408.755C414.052 971.786 418.328 967.51 418.328 962.214V916.516C418.328 911.219 422.604 906.943 427.896 906.943H865.682C870.979 906.943 875.255 911.219 875.255 916.516V962.214C875.255 967.51 879.526 971.786 884.823 971.786H915.771C921.068 971.786 925.344 967.51 925.344 962.214V897.224C925.344 895.672 925.719 894.12 926.437 892.755L1039.55 678.026C1042.96 671.672 1038.34 663.99 1031.12 663.99Z",
    fill: "#14385C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortBreak);
export default __webpack_public_path__ + "static/media/short_break.807fa0d7c682fa4b00d0d24c7dc28bec.svg";
export { ForwardRef as ReactComponent };